import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
import { INSTAGRAM_URL, LEGAL_LINKS, PRODUCT_NAME, SUPPORT_EMAIL } from '../data/config';
const legalLabels: Record<keyof typeof LEGAL_LINKS, string> = {
  terminos: 'Términos y condiciones',
  privacidad: 'Política de privacidad',
  condicionesDeCompra: 'Condiciones de compra'
};
function getInstagramHandle(url: string): string {
  const handle = url.replace(/\/+$/, '').split('/').pop() ?? '';
  return handle ? `@${handle}` : 'Instagram';
}
export function Footer() {
  const legalLinks = (Object.keys(LEGAL_LINKS) as (keyof typeof LEGAL_LINKS)[]).filter(key => LEGAL_LINKS[key].trim().length > 0);
  const linkClass = 'inline-flex items-center gap-2 rounded-lg transition-colors duration-150 ease-out hover:text-brand-orange focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange';
  return <footer id="pie" className="bg-brand-violet text-brand-cream" data-id="element-85" data-mp="2eya1c1v0azqi">
      <div className="mx-auto max-w-page px-5 py-14 text-center md:px-8" data-id="element-86" data-mp="2ezl541ogc7hm">
        <h2 className="text-2xl font-extrabold md:text-3xl" data-id="element-87" data-mp="3labpnqe3hwnq">🎃 {PRODUCT_NAME}</h2>
        <p className="mt-2 text-base text-brand-cream/80" data-id="element-88" data-mp="3gb8vx23kfcv2">Ideas para crear disfraces y compartir Halloween en familia.</p>

        {(SUPPORT_EMAIL || INSTAGRAM_URL) && <div className="mt-6 flex flex-col items-center justify-center gap-3 text-base sm:flex-row sm:gap-8" data-id="element-89" data-mp="3v5dfypk3x4rw">
            {SUPPORT_EMAIL && <a className={linkClass} href={`mailto:${SUPPORT_EMAIL}`} data-id="element-90" data-mp="82icbryzq8eb">
                <MailIcon className="h-4 w-4 text-brand-orange" aria-hidden="true" data-id="element-91" data-mp="33xdnwzdzwrz" />
                {SUPPORT_EMAIL}
              </a>}
            {INSTAGRAM_URL && <a className={linkClass} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-id="element-92" data-mp="hrigdpscntzd">
                <InstagramIcon className="h-4 w-4 text-brand-orange" aria-hidden="true" data-id="element-93" data-mp="cv1uz3cjbtpz" />
                {getInstagramHandle(INSTAGRAM_URL)}
              </a>}
          </div>}

        <div className="mt-10 space-y-2 border-t border-white/10 pt-6 text-sm text-brand-cream/70" data-id="element-94" data-mp="mspo5ouhst61">
          <p data-id="element-95" data-mp="tvw7qgxe1ffz">Producto digital. No incluye materiales físicos.</p>
          <p data-id="element-96" data-mp="yu7g0n81bhw3">Uso personal y familiar. No se permite la reventa ni la redistribución de los archivos.</p>
          {legalLinks.length > 0 && <nav aria-label="Enlaces legales" className="flex flex-wrap justify-center gap-x-5 gap-y-1 pt-2" data-id="element-97" data-mp="13t0uoiz25exu">
              {legalLinks.map(key => <a key={key} href={LEGAL_LINKS[key]} className={`${linkClass} underline underline-offset-4`} data-id="element-98" data-mp="18lk7hdpx861l">
                  {legalLabels[key]}
                </a>)}
            </nav>}
          <p className="pt-2" data-id="element-99" data-mp="1hje2mlby8tn6">© {new Date().getFullYear()} · Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}